import { useState } from 'react';
import { setPreviousSearch } from '../../../../store/slices/productSlice';

const useExpectedState = (dispatch, savedSearch, initialValue = true) => {
  const [isExpected, setIsExpected] = useState(initialValue);

  const updateIsExpected = (newValue) => {
    const booleanValue = Boolean(newValue);
    setIsExpected(booleanValue);
    dispatch(
      setPreviousSearch({
        ...savedSearch,
        isExpected: booleanValue,
      })
    );
  };

  return {
    isExpected,
    setIsExpected,
    updateIsExpected,
  };
};

export default useExpectedState;
